import styled from 'styled-components';

export const Divider = styled.div`
  background-color: ${(props) => props.theme.colours.grey10};
  width: 100%;
  height: 1px;
`;
